import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { PatternSummaryPanel } from './PatternSummaryPanel';
import { RecentActivityPanel } from './RecentActivityPanel';
import { TechStackPanel } from './TechStackPanel';
import { SkillsPanel } from './SkillsPanel';
import { ExplorerLaunchPanel } from './ExplorerLaunchPanel';
import { GBrainMethodologyPanel } from './GBrainMethodologyPanel';

/**
 * G-Brain sidebar for project-specific intelligence
 * Renders only when pathname.startsWith('/g-brain')
 * Provides operator context:
 * - Pattern summary by category
 * - Recent patterns with timestamps
 * - Tech stack and conventions
 * - Discovered skills
 * - Quick-launch 3D explorer
 * - G-Brain methodology reference
 */
export function GBrainSidebar(): React.ReactElement {
  return (
    <aside className="w-60 border-r border-border bg-surface">
      <ScrollArea className="h-full">
        <div className="flex flex-col gap-0">
          {/* Pattern Summary */}
          <div className="px-4 py-3">
            <PatternSummaryPanel />
          </div>
          <Separator />

          {/* Recent Activity */}
          <div className="px-4 py-3">
            <RecentActivityPanel />
          </div>
          <Separator />

          {/* Tech Stack */}
          <div className="px-4 py-3">
            <TechStackPanel />
          </div>
          <Separator />

          {/* Skills */}
          <div className="flex flex-1 flex-col px-4 py-3">
            <SkillsPanel />
          </div>
          <Separator />

          {/* Explorer Launch */}
          <div className="px-4 py-3">
            <ExplorerLaunchPanel />
          </div>
          <Separator />

          {/* Methodology Reference */}
          <div className="px-4 py-3">
            <GBrainMethodologyPanel />
          </div>

          {/* Bottom padding */}
          <div className="h-4" />
        </div>
      </ScrollArea>
    </aside>
  );
}
